import { render, staticRenderFns } from "./ModalTeacherEdit.vue?vue&type=template&id=b81a14bc&scoped=true&lang=pug"
import script from "./ModalTeacherEdit.vue?vue&type=script&lang=ts"
export * from "./ModalTeacherEdit.vue?vue&type=script&lang=ts"
import style0 from "./ModalTeacherEdit.vue?vue&type=style&index=0&id=b81a14bc&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b81a14bc",
  null
  
)

export default component.exports